'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Doctor = function (_BaseIcon) {
  (0, _inherits3.default)(Doctor, _BaseIcon);

  function Doctor() {
    (0, _classCallCheck3.default)(this, Doctor);
    return (0, _possibleConstructorReturn3.default)(this, (Doctor.__proto__ || (0, _getPrototypeOf2.default)(Doctor)).apply(this, arguments));
  }

  (0, _createClass3.default)(Doctor, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M16.83 13.056l-.004.13-.002.246c.002.24-.184.348-.363.452l-.07.044c-.22.138-.46.278-.71.39-.8.35-1.73.594-2.9.776-.4.062-.77.106-1.14.136-.37.032-.72.046-1.08.046h-.11c-.36 0-.71-.014-1.08-.046-.37-.03-.74-.074-1.14-.136-1.17-.182-2.1-.426-2.9-.777-.25-.11-.49-.25-.71-.39-.02-.016-.04-.03-.07-.043-.18-.104-.36-.212-.36-.452v-.375c-.01-.428-.03-.87.14-1.244.2-.424.6-.742 1-1.03.23-.166.46-.316.7-.45.07.148.14.295.22.443.05.085.09.17.14.256-.52.408-.72 1.254-.5 2.1l.06.205.03.088c.03.092.06.187.11.28.05.086.17.342.41.342.03 0 .06-.004.09-.01l.01-.006c.05-.01.08-.01.13-.03.09.05.2.06.3.03.14-.04.23-.16.26-.29h-.01c.005-.02.007-.05.007-.07 0-.2-.17-.37-.38-.37-.18 0-.33.12-.37.28-.002 0-.01-.01-.01-.01l-.02-.04-.03-.06c-.02-.04-.033-.1-.05-.15l-.032-.09c-.292-.84-.08-1.7.47-1.92.07-.01.137-.02.207-.02.534 0 1.106.54 1.36 1.27l.033.09v.01c.03.07.05.13.06.19-.06-.02-.14-.01-.21.01-.194.07-.3.28-.234.47.05.15.19.26.36.26.04 0 .08-.01.12-.02.1-.04.18-.11.23-.21.14-.06.21-.18.21-.36 0-.06-.01-.13-.02-.2-.027-.11-.06-.2-.09-.29-.017-.03-.027-.06-.03-.09-.32-.92-1.06-1.57-1.8-1.57-.07 0-.13.01-.2.02-.064-.11-.13-.23-.186-.34-.07-.13-.134-.26-.195-.39l.24-.12.112-.06c.17-.09.35-.18.524-.26h.01c.188-.08.37-.16.57-.214l.1-.04.01.01c.058.09.117.18.178.27.15.21.3.42.45.62.25.34.504.66.76.98l.39.48.08.094c.077-.4.176-.94.186-1.02v-.087l-.004-.01-.03-.05-.003-.01-.21-.33c-.016-.02-.02-.06-.01-.09.02-.07.045-.14.07-.205V10l.09-.24c.01-.028.03-.025.05-.04.07-.04.9-.04.98 0 .03.012.05.012.06.04.025.08.056.16.084.24l.03.073.078.2c0 .03 0 .067-.015.09-.07.11-.14.22-.21.325l-.007.01c-.012.016-.02.034-.026.05v.04l.01.053c.01.08.11.6.18 1l.06-.07.43-.53c.25-.3.49-.61.72-.93.16-.2.31-.41.46-.63.06-.08.12-.17.17-.26.04.01.07.03.1.04.2.06.38.14.57.22l.01.01c.18.08.35.17.52.26l.12.06c.16.08.32.17.49.26-.03.16-.08.31-.12.46-.12.38-.29.74-.49 1.06-.14-.07-.31-.11-.48-.11-.6 0-1.1.48-1.1 1.08 0 .57.45 1.03 1.02 1.07h.08c.28 0 .54-.1.73-.27.23-.2.37-.483.37-.8 0-.263-.1-.503-.25-.69.204-.32.37-.66.505-1.03.06-.17.12-.35.16-.53.17.1.335.21.49.327.4.29.8.61 1 1.03.17.38.154.82.14 1.25z'
        }, this.getPathProps())),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M13.917 12.115c-.07-.024-.143-.038-.22-.038-.352 0-.64.282-.64.628 0 .346.288.627.64.627.354 0 .64-.28.64-.627 0-.107-.026-.207-.074-.295-.074-.135-.198-.242-.346-.295zm-.292-7.7c-.043-.006-.085-.015-.126-.023.02-.136.04-.253.06-.372.07-.576 0-1.13-.36-1.602-.67-.88-1.6-1.23-2.65-1.292-1.05.063-1.98.412-2.65 1.292-.36.472-.44 1.025-.36 1.602.01.12.04.236.06.372-.04.008-.08.017-.13.023-.28.04-.41.16-.41.438 0 .372.07.734.26 1.066.12.23.34.3.6.31.02.09.03.17.06.26.31.99 1.28 2.29 2.45 2.32h.21c1.16-.04 2.14-1.34 2.45-2.33.03-.09.04-.17.06-.26.26-.01.48-.09.6-.32.18-.34.26-.7.26-1.07 0-.28-.13-.4-.41-.44z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Doctor;
}(_BaseIcon3.default);
/*eslint-enable */


Doctor.defaultProps = {
  width: 20,
  height: 17,
  viewBox: '0 0 20 17'
};
exports.default = Doctor;
//# sourceMappingURL=Doctor.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Doctor.js
// module id = 289
// module chunks = 0